const copyContentToClipBoard = (content: string) => {
    if (content === "") return
    navigator.clipboard.writeText(content).then()
}

export {copyContentToClipBoard}